import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, InputNumber, Row, Select, Space, Table, Tabs, Tag, Tooltip, message } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Badge } from 'flowbite-react';
import dayjs from 'dayjs';
import EditableTable from '../../components/EditableTable';
import { detailedOperationColumns, operationColumns } from '../../utils/TableColumns';
import DetailedOperationModal from '../../modals/DetailedOperationModal';
import StatusComponent from '../../../globalComponents/StatusComponent';
import useTransferAPI from '../../apis/transferAPI';
import EventEmitter from '../../../utils/eventEmitter';
import { confirmQuantities } from '../../utils/alertUtils';
import GoBack from '../../../globalComponents/GoBack';



const shippingPolicies = [
  {value: '', label: ''},
  {value: 'asap', label: 'As soon as possible'},
  {value: 'all_at_once', label: 'When all product are ready'}
]


const StockRequestTransferChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const { transfer, products, locations, operationTypes, contacts } = useLoaderData();

  transfer['scheduled_date'] = transfer.scheduled_date ? dayjs(transfer['scheduled_date'], 'YYYY-MM-DD HH:mm') : '';
  transfer['effective_date'] = transfer.effective_date ? dayjs(transfer['effective_date'], 'YYYY-MM-DD HH:mm') : '';
  const params = useParams();
  const navigate = useNavigate();
  const { create, update, availability, validateRequestTransfer } = useTransferAPI();
  const [operations, setOperations] = useState(transfer.operations ? transfer.operations : []);
  const [detailedOperations, setDetailedOperations] = useState(transfer.operations ? transfer.operations : []);
  const [operation_type, setOperationType] = useState(transfer.number && transfer.number.includes('INT') ? 'internal_transfer' : '');


  const onChangeOperation = option => {
    delete option.value;
    delete option.label;
    form.setFieldValue('location_src_id', option.source);
    form.setFieldValue('location_dest_id', option.destination);
    setOperationType(option.type);
    // console.log(option)
  };


  
  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['operations'] = detailedOperations;
    // data['detailed_operations'] = detailedOperations;
    data['source_location'] = form.getFieldValue('location_src_id');
    data['scheduled_date'] = new Date(data.scheduled_date).toISOString();
    data['effective_date'] = new Date(data.scheduled_date).toISOString();
    create(data);
    // console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    // update(analytic.seo, data, success);
    // console.log(data)
  }

  const updateTransfer = async (status) => {
    let data = form.getFieldsValue();
    data['status'] = status;
    data['operations'] = detailedOperations;
    data['stocklines'] = detailedOperations;
    data['request_status'] = transfer.request_status;
    // data['detailed_operations'] = detailedOperations;
    data['source_location'] = form.getFieldValue('location_src_id');
    data['scheduled_date'] = new Date(data.scheduled_date).toISOString();
    data['effective_date'] = new Date(data.scheduled_date).toISOString();
    let filtered = data.operations.filter(op => op.done_quantity > 0).length;
    if (filtered > 0) {
      validateRequestTransfer(transfer.number.replaceAll('/', '-'), data);
    }else {
      confirmQuantities(validateRequestTransfer, data, setQuantities);
    }
    // console.log(data);
  }

  
  const checkAvailability = () => {
    const number = transfer.number.replaceAll('/', '-');
    let data = {};
    data['stocklines'] = detailedOperations.map(line => ({product_id: line.product_id, demand_quantity: line.demand_quantity}));
    data['location_src_id'] = form.getFieldValue('location_src_id');
    availability(number, data);
  }

  useEffect(() => {
    EventEmitter.subscribe('transfer_response', data => {
      navigate('/inventory/stock-request/'+params.id+'/transfers/'+data.replaceAll('/', '-'));
    });

    EventEmitter.subscribe('to_another_table', data => {
      let array = [...operations];
      let obj = {
        key: operations.length,
        link: data.key,
        product_id: data.product_id,
        description: '',
        packaging_id: '',
        demand_quantity: 0,
        reserved_quantity: data.reserved_quantity,
        done_quantity: data.done_quantity,
      };
      array.push(obj);
      // setOperations(array);
    });
    
    return () => {
      EventEmitter.unsubscribe('transfer_response');
      EventEmitter.unsubscribe('to_another_table');
    }
  },[]);


  operationColumns.forEach((col, idx) => {
    if (operationColumns[idx].dataIndex === 'reserved_quantity' && operation_type !== 'delivery') {
      delete operationColumns[idx];
    }
  });

  const addLine = () => { 
    let array = [...detailedOperations];
    let obj = {
      key: detailedOperations.length,
      product_id: '',
      location_src_id: form.getFieldValue('location_src_id'),
      location_dest_id: form.getFieldValue('location_dest_id'),
      source_package: ' ',
      destination_package: ' ',
      lot_serial_number_id: ' ',
      done_quantity: 0,
      reserved_quantity: 0,
      demand_quantity: 0,
      description: '',
      packaging_id: '',
    };
    array.push(obj);
    setDetailedOperations(array);
    
  };

  const setQuantities = () => {
    let operations_ = [...detailedOperations];
    operations_.forEach((product, idx) => {
      operations_[idx]['done_quantity'] = operations_[idx].demand_quantity;
    });
    setDetailedOperations(operations_);
  }
  

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <GoBack />
          </h3>
        </div>
        {transfer.number && 
        <div className='flex justify-between bg-white'>
          <Flex wrap='wrap' align='center' gap={'small'} style={{maxWidth: '70%'}}>
              {(transfer.status === 'ready' || transfer.status === 'waiting') && 
                <>
                {operation_type !== 'receipt' && transfer.product_availability===0 && <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={checkAvailability}>CHECK AVAILABILITY</Button>}
                <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={()=> updateTransfer('done')}>VALIDATE</Button>
                <Button size='small' type='text' className='font-semibold text-[#189aa0]' onClick={setQuantities}>SET QUANTITIES</Button>
                <Button size='small' type='text' className='font-semibold text-[#189aa0]'>PRINT</Button>
                <Button size='small' type='text' className='font-semibold text-[#189aa0]'>UNLOCK</Button>
                </>
              }
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>PRINT LABELS</Button>
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>SCRAP</Button>
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>CANCEL</Button>
          </Flex>
          <StatusComponent formValue={transfer} name={'TRANSFERS'}/>
        </div>
        }
        
      </div>
      <div className='mt-5 bg-white p-3 shadow'>
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 9}}
          initialValues={transfer.number ? transfer :
            {pick_later: false, shipping_policy: 'asap'}
          }
          variant='borderless'
          disabled = {transfer.status === 'done' ? true : false}
        >
          {/* <Badge className="text-slate-500 text-md bg-transparent	border-b-2">Simulatneous Conditions To Met</Badge> */}
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label={'Contact'} name={'contact_id'} className='font-bold mb-1' required>
                <Select options={contacts.map(contact => ({value: contact.id, label: contact.name}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Operation Type' name={'operation_type_id'} className='font-bold mb-1' required>
                <Select options={operationTypes.map(operation => ({value: operation.id, label: operation.name, type: operation.type, destination: operation.destination_location, source: operation.source_location}))} onChange={(v, option) => onChangeOperation(option)} className='font-normal' />
              </Form.Item>
              { <Form.Item label='Source Location' name={'location_src_id'} className='font-bold mb-1' required>
                <Select options={locations.map(location => ({value: location.id, label: `${location.name}`}))} className='font-normal' />
              </Form.Item>}
              {<Form.Item label='Destination Location' name={'location_dest_id'} className='font-bold mb-1' required>
                <Select options={locations.map(location => ({value: location.id, label: `${location.name}`}))}  className='font-normal' />
              </Form.Item>}
              {operation_type !== 'delivery' &&<Form.Item label='Validated By' name={'validated_by'} className='font-bold mb-1' required>
                <Select options={[]} className='font-normal' />
              </Form.Item>}
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Scheduled Date' name={'scheduled_date'} className='font-bold mb-1' required>
                <DatePicker disabled={transfer.status !== 'done' ? false : true} showTime format={'YYYY-MM-DD HH:mm'} className='font-normal'/>
              </Form.Item>
              <Form.Item label='Effective Date' name={'effective_date'} className='font-bold mb-1' required>
                <DatePicker disabled={transfer.status !== 'done' ? false : true} showTime format={'YYYY-MM-DD HH:mm'} className='font-normal'/>
              </Form.Item>
              <Form.Item label='Source Document' name={'source_document'} className='font-bold mb-1' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Pick Later' name={'is_pick_later'} className='font-bold mb-1' valuePropName='checked' required>
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
          <Tabs 
            type='card'
            items={[
              (operation_type === 'internal_transfer' || operation_type === 'INT') && {
                key: 1,
                label: 'Detailed Operations',
                children: 
                <EditableTable
                  option1={locations}
                  dataSource={detailedOperations}
                  setDataSource={setDetailedOperations}
                  columns={detailedOperationColumns}
                  option2={products}
                  dependant={true}
                />
              },
              {
                key: '2',
                label: 'Operations',
                children: 
                <EditableTable
                  name={'transfer'}
                  dataSource={detailedOperations}
                  setDataSource={setDetailedOperations}
                  columns={operationColumns}
                  option2={products}
                />
              },
              {
                key: '3',
                label: 'Additional Info',
                forceRender: true,
                children: 
                  <Row>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">SHIPPING INFORMATION</Badge> 
                      <Form.Item label='Carrier' name={'carrier'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Tracking Reference' name={'tracking_reference'} className='font-bold mb-1' required>
                        <Input className='input-outline-none font-normal' />
                      </Form.Item>
                      {/* <Form.Item label='Carrier' name={'carrier'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item> */}
                    </Col>
                    <Col md={{span: 11, offset: 1}}>
                      <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">OTHER INFORMATION</Badge> 
                      <Form.Item label='Shipping Policy' name={'shipping_policy'} className='font-bold mb-1' required>
                        <Select options={shippingPolicies} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Responsible' name={'user_id'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Outlet' name={'outlet_id'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item>
                    </Col>
                  </Row>
              },
              {
                key: '4',
                label: 'Note',
                forceRender: true,
                children: 
                <Form.Item name={'note'} className='font-bold mb-1' required>
                  <Input className='input-outline-none font-normal' placeholder='Add an internal note that will be printed at the Picking Operations sheets' />
                </Form.Item>
              }
            ]}
          />          
        </Form>
      </div>
      <DetailedOperationModal />
    </div>
  )
}
export default StockRequestTransferChanges;